import React, { useState } from 'react';
import env from '../../env/env.json';

const InformationsProjet = ({
  formData,
  setFormData,
  handleChange,
  inputFocus,
  handleTrimValue,
  ville,
  page,
  setValidResponse,
  url3DOuest,
  handleChangeFiles,
  handleResetInputFiles,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [modalData, setModalData] = useState({});
  const [indexItem, setIndexItem] = useState(null);
  // const [reference, setReference] = useState(JSON.parse(localStorage.getItem("reference")) || ["ProAutoriPrec-1"])
  const [indexName, setIndexName] = useState(1);

  const taxe_sejour = env.taxe_sejour;
  const files = {};

  // const deleteRefInFormData = () => {
  //     const listReferences = JSON.parse(localStorage.getItem?.("reference"))
  //     const data  = Object.entries(formData)
  //     const currentFormData = {...formData}
  //
  //     listReferences?.forEach(ref => {
  //       const result = data.filter(([key]) => key === ref)
  //       for(let [keyRef] of result){
  //         delete currentFormData[keyRef]
  //       }
  //
  //     })
  //     setFormData({...currentFormData})
  //     localStorage.clear()
  //   }

  return (
    <>
      <header className="d-flex flex-column align-items-center justify-content-center pt-4 pb-4 header">
        <h1 className="title text-center">2. Informations sur le projet</h1>
        <div className="divider--title m-5"></div>
      </header>
      <div className="position-relative ProActivite">
        <label htmlFor="ProActivite" className="form-label fw-bold">
          Quelle activité sera exercée dans le bien&nbsp;?
        </label>
        <select
          className="form-select page-2-required text-truncate select-group getLabel"
          aria-label="Default select example"
          id="ProActivite"
          name="ProActivite"
          value={formData.ProActivite}
          onChange={handleChange}
          onInput={inputFocus}
          required
          disabled
          data-group="ProActivite"
        >
          <option defaultValue=""></option>
          <option value="Location meublée courte durée (location touristique)">
            Location meublée courte durée (location touristique)
          </option>
          {/*<option value="Profession libérale">Profession libérale</option>*/}
          {/*<option value="Activité d'intérêt collectif">Activité d'intérêt collectif</option>*/}
          {/*<option value="Bureaux">Bureaux</option>*/}
          {/*<option value="Commerce">Commerce</option>*/}
          {/*<option value="Artisanat">Artisanat</option>*/}
        </select>
        <div className="invalid-tooltip">
          Veuillez remplir ce champs obligatoire
        </div>
      </div>

      {/* text d'information */}
      <div className="alert alert-info mt-4">
        <i className="fas fa-info-circle"></i>&nbsp;
        <strong>Pour information :</strong>&nbsp;Le propriétaire du bien
        concerné par la demande d'autorisation est tenu, au moment du dépôt de
        sa demande, de certifier que le changement d'usage sera effectué dans le
        strict respect des droits des tiers. Il est également requis que le
        propriétaire s'engage à respecter la charte d'engagement spécifique à la
        commune. Pour consulter cette charte d'engagement veuillez{' '}
        <a href={url3DOuest?.charte} target="blank" rel="noreferrer">
          Cliquez ici
        </a>
        .
      </div>
      <div className="form-check pt-4 position-relative">
        <input
          id="Check8"
          className={
            formData.ProActivite ===
            'Location meublée courte durée (location touristique)'
              ? 'form-check-input page-2-required radio-group ProActivite-group getLabel'
              : 'form-check-input getLabel'
          }
          type="checkbox"
          name="Check8"
          value={
            "J'atteste sur l'honneur avoir pris connaissance de la charte d'engagement des propriétaires"
          }
          onInput={inputFocus}
          onChange={handleChange}
          checked={
            formData.Check8 ===
            "J'atteste sur l'honneur avoir pris connaissance de la charte d'engagement des propriétaires"
          }
          required={
            formData.ProActivite ===
            'Location meublée courte durée (location touristique)'
          }
        />
        <label className="form-check-label" htmlFor="Check8">
          J'atteste sur l'honneur avoir pris connaissance de la charte
          d'engagement des propriétaires
        </label>
        <div className="invalid-tooltip">Veuillez valider les conditions</div>
      </div>
      <div className="divider mt-5 mb-5"></div>

      {/* *********************************************************************
      div qui apparaît lorsque vous cliquez sur "location meublée courte durée"
      ********************************************************************* */}

      <section
        className={
          formData.ProActivite ===
          'Location meublée courte durée (location touristique)'
            ? 'd-block'
            : 'd-none'
        }
      >
        <div
          className={
            formData.PersonneType === 'Une personne morale'
              ? 'pb-4 d-block'
              : 'd-none' || (page === 5 && 'd-none')
          }
        >
          <p className="background--warning p-4">
            <i className="fas fa-info-circle"></i>&nbsp;
            <strong>Pour information</strong>&nbsp; La ville de {ville} autorise
            le changement d'usage temporaire pour les locations touristiques
            pour le propriétaire "en nom propre" dans la limite d'un bien par
            foyer fiscal (autorisation à caractère personnel, valable trois ans,
            reconductible une fois pour une durée totale de 6 ans).
            <br />
            Si ces conditions ne sont pas remplies (hors transfert pour un autre
            logement / reconduction de la durée de validité) une autorisation à
            caractère réel avec compensation est nécéssaire.
          </p>
        </div>
      </section>
      <section>
        {/* *********************************************
        Textarea description du projet (toujours visible)
        ********************************************* */}

        <div className="row mt-5">
          <div className="col-12 position-relative">
            <label className="form-label fw-bold" htmlFor="ProDescription">
              Projet de mise en location saisonnière du bien, en y joignant, le
              cas échéant, des photos (page de validation)&nbsp;:&nbsp;
              <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control w-100 page-2-required getLabel"
              id="ProDescription"
              name="ProDescription"
              maxLength={300}
              value={formData.ProDescription || ''}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
              required
              disabled={page === 5 ? true : false}
            ></textarea>
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InformationsProjet;
